export const accountCollectiveAgreementsCacheKeys = {
  fetch_one: requestOptions => ['fetch_one', requestOptions] as const
}
